if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        // NEW CODE START
        this.variantPicker = document.querySelector('variant-selects');
        if (this.variantPicker) {
            this.variantPicker.addEventListener('variantChange', this.onVariantChange.bind(this));
        }
        // NEW CODE END
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      // NEW CODE START: Variant image filtering logic

      onVariantChange(event) {
        const variant = event.detail.variant;
        // Find the index of the 'Color' option name.
        const colorOptionIndex = event.detail.optionNames.findIndex(name => name.toLowerCase() === 'color');

        if (variant && colorOptionIndex > -1) {
            // Get the option value from the variant object using the found index
            const selectedColor = variant.options[colorOptionIndex];
            
            if (selectedColor) {
                this.filterMedia(selectedColor);
            }
        }
      }

      filterMedia(color) {
        // 1. Convert the color name (e.g., 'Dark Blue') to a handle/slug (e.g., 'dark-blue')
        const colorHandle = color.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-*|-*$/g, '');

        // NEW SELECTORS: Target elements with data-color using the theme's specific classes
        // 1. Select all main media containers (from product-thumbnail.liquid)
        const productMedia = document.querySelectorAll('.product-media-container[data-color][data-media-id]');
        // 2. Select all thumbnail list items (from product-media-gallery.liquid)
        const productThumbnails = document.querySelectorAll('.thumbnail-list__item[data-color]');

        if (!productMedia.length) return;

        let firstMatchMediaId = null;

        // 2. Filter Main Media Gallery
        productMedia.forEach(mediaElement => {
            const mediaColor = mediaElement.dataset.color;
            
            // Show media that either matches the selected color OR has no data-color attribute (i.e., universal image)
            const isMatch = (mediaColor === colorHandle) || (mediaColor === undefined);

            mediaElement.toggleAttribute('hidden', !isMatch);
            
            // Track the ID of the first matching image
            if (isMatch && firstMatchMediaId === null) {
                firstMatchMediaId = mediaElement.dataset.mediaId;
            }
        });

        // 3. Filter Thumbnails
        if (productThumbnails.length) {
            productThumbnails.forEach(thumbnailElement => {
                const mediaColor = thumbnailElement.dataset.color;

                const isMatch = (mediaColor === colorHandle) || (mediaColor === undefined);

                thumbnailElement.toggleAttribute('hidden', !isMatch);
            });
        }
        
        // 4. Set the first matching image as the active media
        const mediaGallery = document.querySelector('media-gallery');
        if (mediaGallery && firstMatchMediaId) {
            // This is the standard method in Dawn/Clarity to change the active slide
            if (typeof mediaGallery.setActiveMedia === 'function') {
                mediaGallery.setActiveMedia(firstMatchMediaId);
            }
        }
      }
// NEW CODE END

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
